import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { Engagement } from '../types';

interface Props {
  data: Engagement;
}

export const EngagementCard: React.FC<Props> = ({ data }) => {
  const chartData = [
    { name: '30d', studied: data.studied_last_30_days },
    { name: '60d', studied: data.studied_last_60_days },
    { name: '90d', studied: data.studied_last_90_days },
  ];

  const formatStudyTime = (minutes: number): string => {
    if (minutes < 60) return `${minutes.toFixed(0)}m`;
    const hours = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  };

  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 24 }}>
      <span style={{ fontSize: 13, fontWeight: 500, color: '#6b7280', display: 'block', marginBottom: 24 }}>
        Engagement
      </span>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
        <div style={{ backgroundColor: '#f9fafb', borderRadius: 8, padding: '12px 16px' }}>
          <span style={{ fontSize: 22, fontWeight: 600, color: '#111827', fontVariantNumeric: 'tabular-nums', display: 'block' }}>
            {formatStudyTime(data.avg_study_time_minutes)}
          </span>
          <p style={{ fontSize: 11, color: '#6B7280', margin: '4px 0 0' }}>avg study time</p>
        </div>
        <div style={{ backgroundColor: '#f9fafb', borderRadius: 8, padding: '12px 16px' }}>
          <span style={{ fontSize: 22, fontWeight: 600, color: '#111827', fontVariantNumeric: 'tabular-nums', display: 'block' }}>
            {data.courses_with_enrollments}
          </span>
          <p style={{ fontSize: 11, color: '#6B7280', margin: '4px 0 0' }}>courses with enrollments</p>
        </div>
      </div>

      <div>
        <p style={{ fontSize: 12, color: '#6B7280', marginBottom: 12 }}>Users who studied</p>
        <div style={{ height: 100 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} barSize={28}>
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: '#6B7280' }}
              />
              <YAxis hide allowDecimals={false} />
              <Tooltip
                formatter={(value: number) => [`${value} users`, 'Studied']}
                contentStyle={{
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                  fontSize: 12,
                  padding: '8px 12px',
                }}
                cursor={{ fill: 'rgba(0,0,0,0.02)' }}
              />
              <Bar dataKey="studied" fill="#3b82f6" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
